module.exports = __webpack_public_path__ + "static/media/loading.0bf98326.gif";